import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { SettingsProvider } from '@/contexts/SettingsContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { TID } from '@/lib/testIds';

import HomePage from '@/pages/HomePage';
import MenuPage from '@/pages/MenuPage';
import BookTablePage from '@/pages/BookTablePage';
import { PUBLIC_MENU_ENABLED } from '@/lib/launchMode';
// OrderPage & ContactPage are preserved on disk (not imported) — reserved for
// future Private Events enquiry / first-party ordering re-enable.

import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import ForgotPasswordPage from '@/pages/admin/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/admin/ResetPasswordPage';
import ChangePasswordPage from '@/pages/admin/ChangePasswordPage';
import AdminUsersPage from '@/pages/admin/AdminUsersPage';
import AdminOverviewPage from '@/pages/admin/AdminOverviewPage';
// AdminOrdersPage preserved on disk for potential future re-enable — not routed.
// import AdminOrdersPage from '@/pages/admin/AdminOrdersPage';
import AdminReservationsPage from '@/pages/admin/AdminReservationsPage';
import AdminMenuItemsPage from '@/pages/admin/AdminMenuItemsPage';
import AdminCategoriesPage from '@/pages/admin/AdminCategoriesPage';
// AdminFeaturedDishesPage & AdminGalleryPage preserved on disk (Phase 11.1 consolidation).
// import AdminFeaturedDishesPage from '@/pages/admin/AdminFeaturedDishesPage';
// import AdminGalleryPage from '@/pages/admin/AdminGalleryPage';
import AdminTastePage from '@/pages/admin/AdminTastePage';
import AdminReviewsPage from '@/pages/admin/AdminReviewsPage';
import AdminSettingsPage from '@/pages/admin/AdminSettingsPage';
import AdminEmailLogPage from '@/pages/admin/AdminEmailLogPage';

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Toaster
                data-testid={TID.toaster}
                richColors
                theme="dark"
                position="top-center"
                toastOptions={{
                  style: {
                    background: 'hsl(0 0% 10%)',
                    color: 'white',
                    border: '1px solid hsl(0 0% 18%)',
                  },
                }}
              />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route
                  path="/menu"
                  element={PUBLIC_MENU_ENABLED ? <MenuPage /> : <Navigate to="/" replace />}
                />
                <Route path="/book" element={<BookTablePage />} />
                {/* Public /order and /contact routes hidden per Phase 9/10.
                    Components preserved (OrderPage, ContactPage) for potential future re-enable
                    (Private Events enquiry flow, first-party ordering). */}

                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/admin/reset-password/:token" element={<ResetPasswordPage />} />
                <Route path="/admin" element={<ProtectedRoute><AdminOverviewPage /></ProtectedRoute>} />
                <Route path="/admin/change-password" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />
                <Route path="/admin/users" element={<ProtectedRoute><AdminUsersPage /></ProtectedRoute>} />
                <Route path="/admin/reservations" element={<ProtectedRoute><AdminReservationsPage /></ProtectedRoute>} />
                <Route path="/admin/menu" element={<ProtectedRoute><AdminMenuItemsPage /></ProtectedRoute>} />
                <Route path="/admin/categories" element={<ProtectedRoute><AdminCategoriesPage /></ProtectedRoute>} />
                <Route path="/admin/taste" element={<ProtectedRoute><AdminTastePage /></ProtectedRoute>} />
                <Route path="/admin/reviews" element={<ProtectedRoute><AdminReviewsPage /></ProtectedRoute>} />
                <Route path="/admin/settings" element={<ProtectedRoute><AdminSettingsPage /></ProtectedRoute>} />
                <Route path="/admin/email-log" element={<ProtectedRoute><AdminEmailLogPage /></ProtectedRoute>} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
